module.exports = __webpack_public_path__ + "img/dropdown-menu.737dba65.svg";